
window.collectionFacetedNavigation = {
  initialized: false,
  themeInitialized: false,
  abortController: null,
  sidebarHydrationController: null,
  currentRoute: window.location.pathname + window.location.search,

  init() {
    if (!document.querySelector('.shopify-section--collection-template')) return;

    if (!this.initialized) {
      document.addEventListener('submit', event => this.onSubmit(event));
      document.addEventListener('click', event => this.onClick(event));

      window.addEventListener('popstate', () => {
        if (!document.querySelector('.shopify-section--collection-template')) return;

        const nextRoute = window.location.pathname + window.location.search;

        if (nextRoute === this.currentRoute) return;

        this.currentRoute = nextRoute;

        this.navigate(window.location.href, {
          historyMode: 'none',
          focus: null,
          scrollToTop: false,
        });
      });

      this.initialized = true;
    }

    this.ensureStatusRegion();
    this.hydrateFilteredCollectionSidebar();
  },

  handleFilterChange(form, input) {
    if (!form || !input || input.type === 'number') return;

    const mobileFilterToggle = form
      .closest('[data-sidebar]')
      ?.querySelector('[data-sidebar-toggle][aria-expanded="true"]');

    if (
      window.PXUTheme.media_queries.medium.matches &&
      mobileFilterToggle
    ) {
      mobileFilterToggle.click();
    }

    this.navigate(this.buildFilterDestination(form), {
      historyMode: 'push',
      focus: {
        type: 'filter',
        name: input.name,
        value: input.value,
      },
      scrollToTop: true,
    });
  },

  handleSortChange(sortBy) {
    if (!sortBy) return;

    const destination = new URL(window.location.href);
    const selectedOption = sortBy.options[sortBy.selectedIndex];
    const defaultValue = selectedOption ? selectedOption.dataset.defaultValue : null;

    destination.searchParams.delete('page');

    if (defaultValue && sortBy.value === defaultValue) {
      destination.searchParams.delete('sort_by');
    } else if (sortBy.value) {
      destination.searchParams.set('sort_by', sortBy.value);
    }

    this.navigate(destination, {
      historyMode: 'push',
      focus: { type: 'sort' },
      scrollToTop: true,
    });
  },

  onSubmit(event) {
    const form = event.target.closest('[data-faceted-filter-form]');

    if (!form || !form.closest('.shopify-section--collection-template')) return;

    event.preventDefault();

    this.navigate(this.buildFilterDestination(form), {
      historyMode: 'push',
      focus: { type: 'heading' },
      scrollToTop: true,
    });
  },

  onClick(event) {
    const link = event.target.closest(
      '.faceted-active-filters__remove-filter, ' +
      '.faceted-active-filters__clear, ' +
      '.faceted-filter-group-display__header-clear, ' +
      '.shopify-section--collection-template .paginate a'
    );

    if (!link || !link.closest('.shopify-section--collection-template')) return;
    if (link.closest('[data-load-more], .js-load-more')) return;
    if (!this.shouldInterceptLink(event, link)) return;

    const destination = new URL(link.href, window.location.origin);

    if (destination.origin !== window.location.origin) return;

    event.preventDefault();

    this.navigate(destination, {
      historyMode: 'push',
      focus: { type: 'heading' },
      scrollToTop: true,
    });
  },

  shouldInterceptLink(event, link) {
    return (
      event.button === 0 &&
      !event.metaKey &&
      !event.ctrlKey &&
      !event.shiftKey &&
      !event.altKey &&
      !link.hasAttribute('download') &&
      (!link.target || link.target === '_self')
    );
  },

  scrollToCollectionTop() {
    const $mainContent = $('#MainContent');

    if (!$mainContent.length) return;

    $('html, body').stop(true).animate({
      scrollTop: $mainContent.offset().top,
    }, 500);
  },

  isElementInViewport(element) {
    if (!element) return false;

    const rect = element.getBoundingClientRect();

    return rect.bottom > 0 && rect.top < window.innerHeight;
  },

  setCollectionLoadingState(section, isLoading) {
    if (!section) return;

    const productList = section.querySelector('.product-list--collection');

    if (!productList) return;

    productList.parentElement.classList.toggle(
      'ajax-collection-loading',
      isLoading
    );

    productList.classList.remove(
      'loading-in-progress',
      'filter-loading',
      'fadeOut',
      'animated'
    );
  },

  getActiveNonAvailabilityInputs(form) {
    return Array.from(
      form.querySelectorAll('.faceted-filter-group-display__list-item-input:checked')
    ).filter(input => input.name !== 'filter.v.availability');
  },

  hasActivePriceRange(form) {
    return Array.from(
      form.querySelectorAll('.faceted-filter-group-display__price-range-input')
    ).some(input => input.value.trim() !== '');
  },

  setAvailabilityState(form) {
    const shouldForceInStock =
      this.getActiveNonAvailabilityInputs(form).length > 0 ||
      this.hasActivePriceRange(form);

    const availabilityInputs = Array.from(
      form.querySelectorAll('input[name="filter.v.availability"]')
    );
    const inStock = availabilityInputs.find(input => input.value === '1');
    const outOfStock = availabilityInputs.find(input => input.value === '0');

    if (inStock) inStock.checked = shouldForceInStock;
    if (outOfStock) outOfStock.checked = false;
  },

  serializeForm(form) {
    const params = new URLSearchParams();

    for (const [name, value] of new FormData(form).entries()) {
      if (String(value).trim() !== '') {
        params.append(name, value);
      }
    }

    params.delete('page');
    return params;
  },

  addCurrentSort(params) {
    const sortBy = document.querySelector(
      '.shopify-section--collection-template [data-sort-by]'
    );

    if (!sortBy) {
      params.delete('sort_by');
      return;
    }

    const selectedOption = sortBy.options[sortBy.selectedIndex];
    const defaultValue = selectedOption ? selectedOption.dataset.defaultValue : null;

    if (defaultValue && sortBy.value === defaultValue) {
      params.delete('sort_by');
    } else if (sortBy.value) {
      params.set('sort_by', sortBy.value);
    }
  },

  buildFilterDestination(form) {
    this.setAvailabilityState(form);

    const sidebar = form.closest('[data-sidebar]');
    const baseCollectionUrl =
      sidebar?.dataset.baseCollectionUrl || window.location.pathname;
    const activeInputs = this.getActiveNonAvailabilityInputs(form);
    const hasPriceRange = this.hasActivePriceRange(form);

    if (activeInputs.length === 1 && !hasPriceRange) {
      const filteredCollectionUrl = activeInputs[0].dataset.filteredCollectionUrl;

      if (filteredCollectionUrl) {
        const destination = new URL(filteredCollectionUrl, window.location.origin);
        const params = new URLSearchParams();

        this.addCurrentSort(params);
        destination.search = params.toString();
        return destination;
      }
    }

    const destination = new URL(baseCollectionUrl, window.location.origin);
    const params = this.serializeForm(form);

    this.addCurrentSort(params);

    if (activeInputs.length === 0 && !hasPriceRange) {
      Array.from(params.keys()).forEach(key => {
        if (key.startsWith('filter.')) params.delete(key);
      });
    }

    destination.search = params.toString();
    return destination;
  },

  buildNativeSidebarUrl(sidebar, destinationUrl) {
    const form = sidebar.querySelector('[data-faceted-filter-form]');

    if (!form) return null;

    this.setAvailabilityState(form);

    const nativeUrl = new URL(
      sidebar.dataset.baseCollectionUrl || window.location.pathname,
      window.location.origin
    );
    const params = this.serializeForm(form);
    const sortBy = destinationUrl.searchParams.get('sort_by');

    params.delete('sort_by');
    if (sortBy) params.set('sort_by', sortBy);

    nativeUrl.search = params.toString();
    return nativeUrl;
  },

  async fetchDocument(url, signal) {
    const response = await fetch(url.href, { signal });

    if (!response.ok) {
      throw new Error(`Collection request failed with status ${response.status}`);
    }

    
    const html = (await response.text()).replace(
      /<noscript\b[^>]*>[\s\S]*?<\/noscript>/gi,
      ''
    );
    

    return new DOMParser().parseFromString(html, 'text/html');
  },

  async prepareDestinationMain(destinationDocument, destinationUrl, signal) {
    const destinationMain = destinationDocument.querySelector('#MainContent');
    const destinationSection = destinationMain?.querySelector(
      '.shopify-section--collection-template'
    );

    if (!destinationMain || !destinationSection) {
      throw new Error('Collection page content was not found in the response.');
    }

    const filteredSidebar = destinationSection.querySelector(
      '[data-sidebar][data-is-filtered-collection="true"]'
    );

    if (filteredSidebar) {
      const nativeSidebarUrl = this.buildNativeSidebarUrl(
        filteredSidebar,
        destinationUrl
      );

      if (nativeSidebarUrl) {
        const baseDocument = await this.fetchDocument(nativeSidebarUrl, signal);
        const baseSidebar = baseDocument.querySelector(
          '.shopify-section--collection-template [data-sidebar]'
        );

        if (baseSidebar) {
          filteredSidebar.replaceWith(baseSidebar);
        } else {
          filteredSidebar.removeAttribute(
            'data-filtered-sidebar-hydration-pending'
          );
          filteredSidebar.removeAttribute('aria-busy');
        }
      }
    }

    return destinationMain;
  },

  async navigate(url, options = {}) {
    const destinationUrl =
      url instanceof URL ? url : new URL(url, window.location.origin);

    if (destinationUrl.origin !== window.location.origin) {
      window.location.assign(destinationUrl.href);
      return;
    }

    const currentMain = document.querySelector('#MainContent');
    const currentSection = currentMain?.querySelector(
      '.shopify-section--collection-template'
    );

    if (!currentMain || !currentSection) {
      window.location.assign(destinationUrl.href);
      return;
    }

    if (this.abortController) {
      this.abortController.abort();
    }

    if (this.sidebarHydrationController) {
      this.sidebarHydrationController.abort();
      this.sidebarHydrationController = null;
    }

    const requestController = window.AbortController
      ? new AbortController()
      : null;

    this.abortController = requestController;

    const signal = requestController?.signal;
    const currentStatus = this.ensureStatusRegion(currentMain);

    currentMain.setAttribute('aria-busy', 'true');
    currentStatus.textContent = 'Loading products...';

    if (options.scrollToTop) {
      this.scrollToCollectionTop();
    }

    this.setCollectionLoadingState(currentSection, true);

    if (
      window.PXUTheme.theme_settings.pagination_type === 'infinite_scroll' &&
      window.Waypoint
    ) {
      Waypoint.destroyAll();
    }

    try {
      const destinationDocument = await this.fetchDocument(
        destinationUrl,
        signal
      );
      const preparedMain = await this.prepareDestinationMain(
        destinationDocument,
        destinationUrl,
        signal
      );
      const importedMain = document.importNode(preparedMain, true);

      this.updateHead(destinationDocument);
      this.updateBodyTemplateClass(destinationDocument);
      this.destroySliders(currentMain);

      currentMain.replaceWith(importedMain);

      if (options.historyMode === 'push') {
        window.history.pushState({}, '', destinationUrl.href);
        this.currentRoute = destinationUrl.pathname + destinationUrl.search;
      }

      this.reinitialize(importedMain);

      this.restoreFocus(importedMain, options.focus);
      this.announceResults(importedMain);
    } catch (error) {
      if (error.name === 'AbortError') return;

      console.error(error);
      window.location.assign(destinationUrl.href);
    } finally {
      if (this.abortController === requestController) {
        this.abortController = null;

        if (currentMain.isConnected) {
          currentMain.removeAttribute('aria-busy');
          this.setCollectionLoadingState(currentSection, false);
          currentStatus.textContent = '';
        }
      }
    }
  },

  updateHead(destinationDocument) {
    const title = destinationDocument.querySelector('title');

    if (title) document.title = title.textContent.trim();

    this.replaceHeadAttribute(
      destinationDocument,
      'link[rel="canonical"]',
      'href'
    );
    this.replaceHeadAttribute(
      destinationDocument,
      'meta[name="description"]',
      'content'
    );
  },

  replaceHeadAttribute(destinationDocument, selector, attribute) {
    const source = destinationDocument.querySelector(selector);
    const current = document.querySelector(selector);

    if (source) {
      if (current) {
        current.setAttribute(attribute, source.getAttribute(attribute) || '');
      } else {
        document.head.appendChild(document.importNode(source, true));
      }
    } else if (current) {
      current.remove();
    }
  },

  updateBodyTemplateClass(destinationDocument) {
    const isCollectionClass = className =>
      className === 'collection' || className.startsWith('collection-');

    Array.from(document.body.classList)
      .filter(isCollectionClass)
      .forEach(className => document.body.classList.remove(className));

    Array.from(destinationDocument.body.classList)
      .filter(isCollectionClass)
      .forEach(className => document.body.classList.add(className));
  },

  destroySliders(main) {
    if (!window.jQuery || !$.fn.flickity) return;

    $(main)
      .find('.flickity-enabled')
      .each((_, slider) => {
        try {
          $(slider).flickity('destroy');
        } catch (_error) {
          // The old collection content is about to be removed regardless.
        }
      });
  },

  reinitialize(main) {
    window.sidebarAccordions.init();

    if ($('.sidebar__collection-filter').length) {
      window.collectionSidebarFilter.init();
    }

    const $main = $(main);

    window.recentlyViewed.init();

    if (window.PXUTheme.currency.show_multiple_currencies) {
      window.currencyConverter.convertCurrencies();
    }

    window.productPage.init();
    window.productPage.runOptionSelector($main);

    if (window.Shopify.PaymentButton) {
      window.Shopify.PaymentButton.init();
    }

    $('body').off('click', '.swatch-element');
    window.productPage.productSwatches();

    $('.swatch_options label')
      .off('click.collectionFacetedNavigation')
      .on('click.collectionFacetedNavigation', function() {
        window.quickShop.toggleSwatchImages($(this));
      });

    if (window.PXUTheme.theme_settings.collection_secondary_image) {
      window.imageFunctions.showSecondaryImage();
    }

    window.hideNoScript();
    window.utils.initializeSectionWrapper();

    if (window.PXUTheme.theme_settings.pagination_type === 'infinite_scroll') {
      window.enableInfiniteScroll('[data-product-list]');
    }
  },

  ensureStatusRegion(main = document.querySelector('#MainContent')) {
    if (!main) return null;

    let status = main.querySelector('[data-faceted-filter-status]');

    if (!status) {
      status = document.createElement('p');
      status.setAttribute('data-faceted-filter-status', '');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      Object.assign(status.style, {
        position: 'absolute',
        width: '1px',
        height: '1px',
        padding: '0',
        margin: '-1px',
        overflow: 'hidden',
        clip: 'rect(0, 0, 0, 0)',
        whiteSpace: 'nowrap',
        border: '0',
      });
      main.appendChild(status);
    }

    return status;
  },

  announceResults(main) {
    const status = this.ensureStatusRegion(main);
    const productCount = main.querySelectorAll(
      '.product-list--collection [data-load-more--grid-item]'
    ).length;
    const message =
      productCount === 1
        ? 'Product results updated. 1 product shown.'
        : `Product results updated. ${productCount} products shown.`;

    window.setTimeout(() => {
      status.textContent = message;
    }, 50);
  },

  restoreFocus(main, focus) {
    if (!focus) return;

    let target = null;

    if (focus.type === 'filter') {
      target = Array.from(
        main.querySelectorAll('.faceted-filter-group-display__list-item-input')
      ).find(input => input.name === focus.name && input.value === focus.value);
    } else if (focus.type === 'sort') {
      target = main.querySelector('[data-sort-by]');
    }

    if (target && window.jQuery && !$(target).is(':visible')) {
      target = null;
    }

    if (target && !this.isElementInViewport(target)) {
      target = null;
    }

    if (!target) {
      target = main.querySelector('h1') || main;
    }

    const addedTabIndex = !target.hasAttribute('tabindex');

    if (addedTabIndex) target.setAttribute('tabindex', '-1');

    try {
      target.focus({ preventScroll: true });
    } catch (_error) {
      target.focus();
    }

    if (addedTabIndex) {
      target.addEventListener(
        'blur',
        () => target.removeAttribute('tabindex'),
        { once: true }
      );
    }
  },

  revealFilteredSidebarFallback(sidebar) {
    if (!sidebar || !sidebar.isConnected) return;

    sidebar.removeAttribute('data-filtered-sidebar-hydration-pending');
    sidebar.removeAttribute('aria-busy');
    delete sidebar.dataset.ajaxHydrating;
  },

  async hydrateFilteredCollectionSidebar() {
    const sidebar = document.querySelector(
      '.shopify-section--collection-template ' +
      '[data-sidebar][data-is-filtered-collection="true"]'
    );

    if (!sidebar || sidebar.dataset.ajaxHydrating === 'true') return;

    const nativeSidebarUrl = this.buildNativeSidebarUrl(
      sidebar,
      new URL(window.location.href)
    );

    if (!nativeSidebarUrl) {
      this.revealFilteredSidebarFallback(sidebar);
      return;
    }

    const hydrationPageUrl = window.location.href;
    const hydrationController = window.AbortController
      ? new AbortController()
      : null;

    this.sidebarHydrationController = hydrationController;

    sidebar.dataset.ajaxHydrating = 'true';
    sidebar.setAttribute('aria-busy', 'true');

    try {
      const baseDocument = await this.fetchDocument(
        nativeSidebarUrl,
        hydrationController?.signal
      );
      const baseSidebar = baseDocument.querySelector(
        '.shopify-section--collection-template [data-sidebar]'
      );

      if (
        !baseSidebar ||
        !sidebar.isConnected ||
        !sidebar.hasAttribute('data-filtered-sidebar-hydration-pending') ||
        window.location.href !== hydrationPageUrl
      ) {
        this.revealFilteredSidebarFallback(sidebar);
        return;
      }

      const importedSidebar = document.importNode(baseSidebar, true);

      importedSidebar.removeAttribute('aria-busy');
      sidebar.replaceWith(importedSidebar);
      window.sidebarAccordions.init();

      if ($('.sidebar__collection-filter').length) {
        window.collectionSidebarFilter.init();
      }
    } catch (error) {
      if (error.name === 'AbortError') return;

      console.warn('Unable to hydrate the filtered collection sidebar.', error);
      this.revealFilteredSidebarFallback(sidebar);
    } finally {
      if (this.sidebarHydrationController === hydrationController) {
        this.sidebarHydrationController = null;
      }
    }
  },
};

